/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'ia.components.inactivityModal.header',
    defaultMessage: 'Session expiration'
  },
  aboutToExpire: {
    id: 'ia.components.inactivityModal.aboutToExpire',
    defaultMessage:
      'Your session will expire in {minutesRemaining, plural, one {# minute} other {# minutes}} due to inactivity.'
  },
  expired: {
    id: 'ia.components.inactivityModal.expired',
    defaultMessage:
      'Your session has expired: you must log out and log back in.'
  },
  continueSession: {
    id: 'ia.components.inactivityModal.save',
    defaultMessage: 'Continue session'
  },
  logOut: {
    id: 'ia.components.inactivityModal.logOut',
    defaultMessage: 'Log out'
  }
});
